// extracted by css-extract-rspack-plugin
export default {"warningBox":"ContractTargetWarnings__warningBox--yKUUz","warningBoxText":"ContractTargetWarnings__warningBoxText--MmuAc","closeButton":"ContractTargetWarnings__closeButton--xq45t"};